import { startTransition, useCallback, useContext, useEffect, useState } from 'react';
import { DataHubService } from 'src/core/services/datahub';
import { ClickContentCheckAllPagesSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentCheckAllPagesSchema';
import { SelectedContentContext } from 'src/modules/contentList/contexts/selectedContentContext';
export function useSelectModule(moduleId) {
    const { selectModule, selectedModules, moduleIsIndeterminate } = useContext(SelectedContentContext);
    const [isSelected, setIsSelected] = useState(false);
    useEffect(function handleSelectedModulesChange() {
        setIsSelected(selectedModules[moduleId] ?? false);
    }, [selectedModules, moduleId]);
    const onSelect = useCallback((event) => {
        const { checked } = event.target;
        setIsSelected(checked);
        // Prevent delay on isSelected update
        startTransition(() => {
            selectModule(moduleId, checked);
        });
        DataHubService.sendEvent({
            schema: new ClickContentCheckAllPagesSchema({
                actionType: checked ? 'SELECT' : 'UNSELECT'
            })
        });
    }, [moduleId, selectModule]);
    return {
        isSelected,
        isIndeterminate: moduleIsIndeterminate(moduleId),
        onSelect
    };
}
